import * as React from 'react'
import { Route, RouteComponentProps, Switch } from 'react-router'
import ServiceDays from '../../../containers/services/ServiceDays'
import ServiceEditBottomBar from '../../../containers/services/ServiceEditBottomBar'
import ServiceEditHeader from '../../../containers/services/ServiceEditHeader'
import ServiceEditMainInfo from '../../../containers/services/ServiceEditMainInfo'
import ServiceEditTabs from '../../../containers/services/ServiceEditTabs'
import ServicePricingBreakdown from '../../../containers/services/ServicePricingBreakdown'
import ServiceProviders from '../../../containers/services/ServiceProviders'
import ServiceProducts from '../../../containers/services/ServiceProducts'
import { SERVICE_EDIT_URL } from '../../../state/constants/index'
import EntityErrorMessage from '../../ui/entity/EntityErrorMessage'
import GoinZonesPane from '../../../containers/services/GoinZonesPane'
import { withNotification } from '../../ui/notification-provider'
import { IMap, IServiceLocationObject, IStateMetadata, IZoneObject } from '../../../types/index'
import ServiceEditPassengerType from '../../../containers/services/ServiceEditPassengerType'
import ServiceEditSuggestedLocations from 'src/containers/services/ServiceEditSuggestedLocations'
import ServiceEditGroupRideSettings from 'src/containers/services/ServiceEditGroupRideSettings'
import ServiceEditDesignatedHotspots from 'src/containers/services/ServiceEditDesignatedHotspots'

interface IServiceEditPaneProps {
  serviceId?: string
  updatingError: string
  fetchingError: string
  routeProps: RouteComponentProps<any>
  onComponentMount: (serviceId: string) => void
  onHideErrorClick: () => void
  notification?: any
  zones: IMap<IZoneObject>
  locations: IServiceLocationObject[]
}

interface IServiceEditPaneState {
  loading: boolean
}

class ServiceEditPane extends React.Component<IServiceEditPaneProps> {
  public state = {
    loading: false
  }

  private mainInfoFormRef: any

  private serviceProvidersFormRef: any

  private serviceProductsFormRef: any

  private serviceDaysFormRef: any

  private serviceZonesFormRef: any

  private servicePricingFormRef: any

  private servicePassengerTypeFormRef: any

  private serviceSuggestedLocationFormRef: any

  private serviceGroupRideSettingsFormRef: any

  private serviceDesignatedHotspotsFormRef: any

  private stepStrategy = [
    {
      test: (url: string) => /(edit$|edit\/$)/.test(url),
      submit: () => this.mainInfoFormRef.submitForm(),
      url: ''
    },
    {
      test: (url: string) => new RegExp(SERVICE_EDIT_URL.PROVIDERS_AND_PRODUCTS).test(url),
      submit: () => this.serviceProvidersFormRef.click(),
      url: `/${SERVICE_EDIT_URL.PROVIDERS_AND_PRODUCTS}`
    },
    {
      test: (url: string) => new RegExp(SERVICE_EDIT_URL.PRODUCTS).test(url),
      submit: () => this.serviceProductsFormRef.click(),
      url: `/${SERVICE_EDIT_URL.PRODUCTS}`
    },
    {
      test: (url: string) => new RegExp(SERVICE_EDIT_URL.SERVICE_DAYS_AND_HOURS).test(url),
      submit: () => this.serviceDaysFormRef.click(),
      url: `/${SERVICE_EDIT_URL.SERVICE_DAYS_AND_HOURS}`
    },
    {
      test: (url: string) => new RegExp(SERVICE_EDIT_URL.PRICING_BREAKDOWN).test(url),
      submit: () => this.servicePricingFormRef.submitForm(),
      url: `/${SERVICE_EDIT_URL.PRICING_BREAKDOWN}`
    },
    // URL for Rider Type Edit
    {
      test: (url: string) => new RegExp(SERVICE_EDIT_URL.PASSENGER_TYPES).test(url),
      submit: () => this.servicePassengerTypeFormRef.submitForm(),
      url: `/${SERVICE_EDIT_URL.PASSENGER_TYPES}`
    },
    {
      test: (url: string) => new RegExp(SERVICE_EDIT_URL.SUGGESTED_LOCATIONS).test(url),
      submit: () => this.serviceSuggestedLocationFormRef.onSave(),
      url: `/${SERVICE_EDIT_URL.SUGGESTED_LOCATIONS}`
    },
    {
      test: (url: string) => new RegExp(SERVICE_EDIT_URL.GOIN_ZONES).test(url),
      submit: () => {
        if (Object.keys(this.props.zones).length > 0) {
          this.props.notification.addNotification({
            title: 'Saved zones!',
            level: 'success'
          })
          this.handleDataSaved(`/${SERVICE_EDIT_URL.GOIN_ZONES}`)()
        } else {
          this.props.notification.addNotification({
            title: 'Please create at least one zone!',
            level: 'error'
          })
        }
      },
      url: `/${SERVICE_EDIT_URL.GOIN_ZONES}`
    },
    {
      test: (url: string) => new RegExp(SERVICE_EDIT_URL.GROUP_RIDE_SETTINGS).test(url),
      submit: () => this.serviceGroupRideSettingsFormRef.submitForm(),
      url: `/${SERVICE_EDIT_URL.GROUP_RIDE_SETTINGS}`
    },
    {
      test: (url: string) => new RegExp(SERVICE_EDIT_URL.DESIGNATED_HOTSPOTS).test(url),
      submit: () => this.serviceDesignatedHotspotsFormRef.submitForm(),
      url: `/${SERVICE_EDIT_URL.DESIGNATED_HOTSPOTS}`
    }
  ]

  constructor(props: IServiceEditPaneProps) {
    super(props)
  }

  public componentDidMount() {
    this.props.onComponentMount(this.props.routeProps.match.params.id)
  }

  public render() {
    const { routeProps } = this.props

    return (
      <div>
        {this.errorText() && (
          <EntityErrorMessage onCloseBtnClick={this.handleHideErrorClick}>{this.errorText()}</EntityErrorMessage>
        )}
        <ServiceEditHeader />
        <ServiceEditTabs routeProps={routeProps} />
        <Switch>
          <Route
            path={`${routeProps.match.path}/${SERVICE_EDIT_URL.PROVIDERS_AND_PRODUCTS}`}
            render={this.renderProvidersAndProducts}
          />
          <Route path={`${routeProps.match.path}/${SERVICE_EDIT_URL.PRODUCTS}`} render={this.renderProducts} />
          <Route
            path={`${routeProps.match.path}/${SERVICE_EDIT_URL.SERVICE_DAYS_AND_HOURS}`}
            render={this.renderServiceDays}
          />
          <Route path={`${routeProps.match.path}/${SERVICE_EDIT_URL.GOIN_ZONES}`} render={this.renderZones} />
          <Route
            path={`${routeProps.match.path}/${SERVICE_EDIT_URL.PRICING_BREAKDOWN}`}
            render={this.renderPricingBreakdown}
          />
          {/* PricingType */}
          <Route
            path={`${routeProps.match.path}/${SERVICE_EDIT_URL.PASSENGER_TYPES}`}
            render={this.renderPricingType}
          />
          <Route
            path={`${routeProps.match.path}/${SERVICE_EDIT_URL.SUGGESTED_LOCATIONS}`}
            render={this.renderSuggestedLocations}
          />
          {/* PricingType */}

          <Route
            path={`${routeProps.match.path}/${SERVICE_EDIT_URL.GROUP_RIDE_SETTINGS}`}
            render={this.renderGroupRideSettings}
          />

          <Route
            path={`${routeProps.match.path}/${SERVICE_EDIT_URL.DESIGNATED_HOTSPOTS}`}
            render={this.renderDesignatedHotspots}
          />

          <Route path={`${routeProps.match.path}/${SERVICE_EDIT_URL.MAIN_INFO}`} render={this.renderMainInfo} />
        </Switch>

        <div className='absolute bottom-0 col-12'>
          <ServiceEditBottomBar
            onSaveClick={this.handleSaveButtonClick}
            onCancelClick={this.handleCancelClick}
            loading={this.state.loading}
          />
        </div>
      </div>
    )
  }

  private errorText = () => {
    if (this.props.updatingError) {
      return this.props.updatingError
    }
    if (this.props.fetchingError) {
      return this.props.fetchingError
    }
    return ''
  }

  private handleHideErrorClick = () => {
    this.props.onHideErrorClick()
  }

  private setLoading = (loading: boolean) => {
    this.setState({
      loading
    })
  }

  private renderDesignatedHotspots = (props: RouteComponentProps<any>) => {
    return (
      <ServiceEditDesignatedHotspots
        formRef={this.serviceDesignatedHotspotsFormRefCallback}
        serviceId={this.props.serviceId}
        setLoading={this.setLoading}
        onStepSuccessfullyCompleted={this.handleDataSaved(`/${SERVICE_EDIT_URL.DESIGNATED_HOTSPOTS}`)}
      />
    )
  }

  private renderMainInfo = (props: RouteComponentProps<any>) => (
    <ServiceEditMainInfo
      formRef={this.mainInfoFormRefCallback}
      serviceId={this.props.routeProps.match.params.id}
      onStepSuccessfullyCompleted={this.handleDataSaved('')}
    />
  )
  private renderGroupRideSettings = (props: RouteComponentProps<any>) => (
    <ServiceEditGroupRideSettings
      formRef={this.serviceGroupRideSettingsFormRefCallback}
      serviceId={this.props.serviceId}
      onStepSuccessfullyCompleted={this.handleDataSaved(`/${SERVICE_EDIT_URL.GROUP_RIDE_SETTINGS}`)}
    />
  )

  private renderProvidersAndProducts = (props: RouteComponentProps<any>) => {
    if (!this.props.serviceId) {
      return null
    }
    return (
      <ServiceProviders
        formRef={this.serviceProvidersFormRefCallback}
        onStepSuccessfullyCompleted={this.handleDataSaved(`/${SERVICE_EDIT_URL.PROVIDERS_AND_PRODUCTS}`)}
      />
    )
  }

  private renderProducts = (props: RouteComponentProps<any>) => {
    if (!this.props.serviceId) {
      return null
    }
    return (
      <ServiceProducts
        {...props}
        formRef={this.serviceProductsFormRefCallback}
        onStepSuccessfullyCompleted={this.handleDataSaved(`/${SERVICE_EDIT_URL.PRODUCTS}`)}
      />
    )
  }

  private renderServiceDays = (props: RouteComponentProps<any>) => {
    if (!this.props.serviceId) {
      return null
    }
    return (
      <ServiceDays
        formRef={this.serviceDaysFormRefCallback}
        onStepSuccessfullyCompleted={this.handleDataSaved(`/${SERVICE_EDIT_URL.SERVICE_DAYS_AND_HOURS}`)}
      />
    )
  }

  private renderZones = (props: RouteComponentProps<any>) => {
    console.log('calling render zones')
    console.log('props: ', props)
    const showMessage = (msg: string) => {
      console.log('showing message: ', msg)
    }
    return <GoinZonesPane serviceId={this.props.serviceId} {...props} showMessage={showMessage} />
    /*
      <ServiceEditZones
        formRef={this.serviceZonesFormRefCallback}
        onStepSuccessfullyCompleted={this.handleDataSaved(`/${SERVICE_EDIT_URL.GOIN_ZONES}`)}
      />
    */
  }

  private renderPricingBreakdown = (props: RouteComponentProps<any>) => {
    if (!this.props.serviceId) {
      return null
    }
    return (
      <ServicePricingBreakdown
        formRef={this.servicePricingFormRefCallback}
        onCreateServiceCompleted={this.handleDataSaved(`/${SERVICE_EDIT_URL.PRICING_BREAKDOWN}`)}
      />
    )
  }
  /* PricingType */
  private renderPricingType = (props: RouteComponentProps<any>) => {
    if (!this.props.serviceId) {
      return null
    }
    return (
      <ServiceEditPassengerType
        serviceId={this.props.serviceId}
        formRef={this.servicePassengerTypeFormRefCallback}
        onStepSuccessfullyCompleted={this.handleDataSaved(`/${SERVICE_EDIT_URL.PASSENGER_TYPES}`)}
      />
    )
  }
  /* PricingType */

  private renderSuggestedLocations = (props: RouteComponentProps<any>) => {
    if (!this.props.serviceId) {
      return null
    }
    return (
      <ServiceEditSuggestedLocations
        showMessage={this.errorText}
        {...props}
        serviceId={this.props.serviceId}
        onRef={(ref: any) => (this.serviceSuggestedLocationFormRef = ref)}
        routeProps={this.props.routeProps}
        onStepSuccessfullyCompleted={this.handleDataSaved(`/${SERVICE_EDIT_URL.SUGGESTED_LOCATIONS}`)}
      />
    )
  }

  private mainInfoFormRefCallback = (node: any) => {
    this.mainInfoFormRef = node
  }

  private serviceGroupRideSettingsFormRefCallback = (node: any) => {
    this.serviceGroupRideSettingsFormRef = node
  }

  private serviceDesignatedHotspotsFormRefCallback = (node: any) => {
    this.serviceDesignatedHotspotsFormRef = node
  }

  private serviceProvidersFormRefCallback = (node: any) => {
    this.serviceProvidersFormRef = node
  }

  private serviceProductsFormRefCallback = (node: any) => {
    this.serviceProductsFormRef = node
  }

  private serviceDaysFormRefCallback = (node: any) => {
    this.serviceDaysFormRef = node
  }

  private serviceZonesFormRefCallback = (node: any) => {
    this.serviceZonesFormRef = node
  }

  private servicePricingFormRefCallback = (node: any) => {
    this.servicePricingFormRef = node
  }

  private servicePassengerTypeFormRefCallback = (node: any) => {
    this.servicePassengerTypeFormRef = node
  }

  private handleSaveButtonClick = () => {
    console.log('handleSaveButtonClick', this.props)
    const stepItem = this.stepStrategy.find(it => it.test(this.props.routeProps.location.pathname))
    console.log('STEP ITEM', stepItem)
    if (stepItem) {
      stepItem.submit()
    }
  }

  private handleDataSaved = (url: string) => () => {
    this.props.routeProps.history.push(`/services/${this.props.serviceId}${url}`)
  }

  private handleCancelClick = () => {
    const stepItem = this.stepStrategy.find(it => it.test(this.props.routeProps.location.pathname))
    if (stepItem) {
      this.props.routeProps.history.push(`/services/${this.props.serviceId}${stepItem.url}`)
    }
  }
}

export default withNotification(ServiceEditPane)



// WEBPACK FOOTER //
// ./src/components/services/edit/ServiceEditPane.tsx